<template>
  <div>
    <div class="search-background">
      <el-input
        class="search"
        placeholder="请输入检索内容"
        suffix-icon="el-icon-search"
      >
      </el-input>
    </div>
  </div>
</template>
<script>
import api from '@/utils/api'
export default {
  name: 'Search',
}
</script>
<style scoped>
/deep/ .el-input__inner {
  border: none;
}
.search {
  margin-top: 15px;
  margin-bottom: .9375rem;
  margin-left: 1.5rem;
  width: 43.875rem;
  height: 4.5rem;
  font-size: 1.5rem;
}
/deep/ .el-input__icon {
  margin-top: 1.15625rem;
  margin-right: 1.43rem;
}
/deep/ .el-icon-search:before {
  font-size: 1.91375rem !important;
}
/deep/ .el-input--suffix .el-input__inner {
  height: 43.875rem;
  height: 4.5rem;
}
.search-background {
  background-color: #fafafa;
}
</style>
